import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=a5d0b7b2&scoped=true&"
import script from "./Hint.vue?vue&type=script&lang=js&"
export * from "./Hint.vue?vue&type=script&lang=js&"
import style0 from "./Hint.vue?vue&type=style&index=0&id=a5d0b7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d0b7b2",
  null
  
)

export default component.exports